"use client";
import { getSubjectColorIndex } from "@/lib/strapi/formatters";
import { Button, Container } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { Resources, SubTopic, Topic } from "@tsTypes/subject-schema";
import RawResourceIcon from "app/components/logos/resources/RawResourceIcon";
import SyllabusDrawer from "../(withSyllabusBar)/components/SyllabusDrawer";
import WaveBanner from "../../../../components/footer/components/WaveBanner";
import classes from "./SubjectContainer.module.css";
import SubjectFooterLinks from "./SubjectFooterLinks";

export default function SubjectContainer({
  subjectName,
  currentResource,
  children,
  topicSyllabusPointData,
  subjectDocumentId,
}: {
  subjectName: string;
  currentResource?: Resources;
  children: React.ReactNode;
  topicSyllabusPointData?: {
    documentId: Topic["documentId"];
    TopicDescription: Topic["TopicDescription"];
    RelatedSubTopics: Pick<SubTopic, "documentId" | "RelatedSyllabusPoints">[];
  };
  subjectDocumentId?: string;
}) {
  const subjectNameLower = subjectName.toLowerCase();
  const subjectColorIndex = getSubjectColorIndex(subjectNameLower);
  const [drawOpen, { open, close }] = useDisclosure(false);
  return (
    <>
      <Container fluid className={classes.mainWrapper}>
        {topicSyllabusPointData && subjectDocumentId && (
          <>
            <SyllabusDrawer
              subjectDocumentId={subjectDocumentId}
              topicSyllabusPointData={topicSyllabusPointData}
              drawOpen={drawOpen}
              close={close}
            />
            <Button
              size="md"
              name={`Toggle IB ${subjectName} syllabus`}
              onClick={open}
              pos={"fixed"}
              right={0}
              bottom={"var(--mantine-spacing-md)"}
              leftSection={
                <RawResourceIcon
                  subjectNameLower={subjectNameLower}
                  resource="syllabus"
                  size={26}
                />
              }
              color={`${subjectColorIndex}.6`}
              variant={"filled"}
              radius={"md"}
              className={classes.syllabusButton}
            >
              Syllabus
            </Button>
          </>
        )}
        <Container className={classes.contentContainer}>{children}</Container>
      </Container>
      <WaveBanner subjectNameLower={subjectNameLower} />
      <SubjectFooterLinks
        subjectName={subjectName}
        currentResource={currentResource}
      />
    </>
  );
}
